import React from 'react';
import Customers from '../../components/AdminNext/Customers';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Customers — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Customers />
      </HeadLessLayout>
    )
  };
}

export default action;
